import { extractPageFromPath } from '@ignitesales/neuro-application';
import ReactGA from "react-ga4";
import LinkedInTag from 'react-linkedin-insight';
import { getUSPrivacy } from './privacyHelpers.mjs';
import ReactPixel from 'react-facebook-pixel';

const DC_FLOODLIGHT = 'DC-9100576';

const UNIVERSAL_ANALYTICS = 'UA-52949408-1';
const AD_WORDS = 'AW-1013536406';
const LINKEDIN_ID = '4645028';
const LINKEDIN_REGIS_ID = '19142884';
const LINKEDIN_WEALTH_ID = '19142892';
const BUSINESS = 'business'
const CONSUMER = 'consumer'
const WEALTH = 'wealth'

const META_PIXEL_EVENTS = {
  regisLead: 'PWM_WealthGuideRegisLead',
  wealthLead: 'PWM_WealthGuidePrivateWealthLead'
};

const META_PIXEL_ID = '499108531775714';

const analyticsHmdText = {
  bank: 'checking',
  saveAndInvest: 'savings',
  loansAndLines: 'loan',
  creditCards: 'credit cards',
};

const analyticsCustomerText = {
  yesPersonal: 'personal',
  yesBusiness: 'business',
  yesBoth: 'both',
  no: 'neither',
};

const extractGuideChannel = (host) => {
  if(host.includes('business')) return BUSINESS
  if(host.includes('consumer')) return CONSUMER
  if(host.includes('wealth')) return WEALTH
  return 'regions'
}

const convertToLowerCaseWithSpaces = (input) => {
  return input.replace(/-/g, ' ')
      .replace(/([A-Z])/g, ' $1').toLowerCase()
}

const getPageName = path => {
  if(path.custom) return `rdc|help me decide|${path.custom}`; // Note: as of Dec-2024 only being used on wealth on form submitting

  const channel = extractGuideChannel(window.location.host);
  const page = extractPageFromPath(path);
  const removeDashes = s => s.replace(/-/g, '');
  if (page.type === 'survey') {
    return `rdc|help me decide|${channel}|survey.${removeDashes(page.path.key)}.${removeDashes(page.page.key)}`;
  } else {
    return `rdc|help me decide|${channel}|${page.type}`;
  }
};

//adobe analytics
const getPageNameEnsightenOnly = path => {
  if(path.custom) return `rdc|help me decide|${path.custom}`; // Note: as of Dec-2024 only being used on wealth on form submitting 

  const page = extractPageFromPath(path);

  if (page.type === 'survey') {
    return `rdc|help me decide|survey ${convertToLowerCaseWithSpaces(page.path.key)} ${convertToLowerCaseWithSpaces(page.page.key)}`;
  } else {
    return `rdc|help me decide|${page.type}`;
  }
};

const getUrl = path => {
  const page = extractPageFromPath(path);
  const origin = window.location.origin;
  const pathname = page.type === 'survey' ? `${origin}/guide/${page.path.key}/${page.page.key}` : origin;
  return pathname;
};

const dispatchGoogleAnalyticsPageView = (pageName)=>{
  ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: pageName, send_to: [UNIVERSAL_ANALYTICS, AD_WORDS] });
}

/**
 * This is only for use with ENSIGHTEN
 */
// dispatch custom event to ensighten listener
function dispatchAnalyticsEvent(event) {

  try {
    window.analytics_event = { detail: event };
  } catch (ex) {
    console.error('Error dispatching custom event');
  }
}

export const analyticEvents = {
  click: 'clickAction',
  findBranch: 'findBranch',
  accordionOpen: 'accordionExpansion',
  accordionClose: 'accordionClose',
  formComplete: 'formComplete',
  pageLoad: 'pageLoad'
};

export const sendTo = {
  summary: `${DC_FLOODLIGHT}/en/welsumm+standard`,
  start: `${DC_FLOODLIGHT}/start/welappst+standard`,
  letsConnectSubmit: `${DC_FLOODLIGHT}/conf/welappcp+standard`,//contact submit
  letsConnectOpenFormButton: `${DC_FLOODLIGHT}/en/welletsc+standard`,
  // TODO: should this even be used?
  wealthAdvisor: `${DC_FLOODLIGHT}/conf/regio006+standard`,
  financialAdvisor: `${DC_FLOODLIGHT}/conf/regio005+standard`,
}

export function processPageView(state) {
  const { pages, user } = state;

  const currentPageUrl = pages?.currentPageUrl;
  const uuid = user?.uuid;
  let channel, pageName, pageNameEnsighten, url;

  try {
    channel = extractGuideChannel(window.location.host);
    pageName = getPageName(currentPageUrl);
    pageNameEnsighten = getPageNameEnsightenOnly(currentPageUrl);
    url = getUrl(currentPageUrl);

  } catch (error) {
    console.error('Error processing page view', error);
  }

  var event = {
    'pageName': pageName || 'pageNameError',
    'events': 'pageViewed',
    'subDomain': 'rdc',
    'language': 'en',
    'country': 'us',
    'uuid': uuid,
    'url': url || 'urlError',
    "eVar": channel || 'channelError',
  };

  dispatchGoogleAnalyticsPageView(pageName);
  trackLinkedIn();
  event.pageName = pageNameEnsighten;
  dispatchAnalyticsEvent(event);// fires window.analytics_event on page views
}

export function processEvent({eventType, description} = {}) {
  var event = {
    'events': eventType,
    'keyName': description,
  };

  dispatchAnalyticsEvent(event);

  ReactGA.event({
    action: eventType,
    label: description,
    // the below threw warnings and did allow event to fire if
    // they were left out... fun
    category: eventType,
    action: eventType,
    send_to: UNIVERSAL_ANALYTICS
  });
}

/**
 * Process Online event
 * This may be needed from client.. leaving here for now
 * @param {*} eventType
 * @param {*} description
 */
export function processOnlineEvent({eventType, description} = {}) {
  ReactGA.event({
    action: eventType,
    label: description,
    // the below threw warnings and did allow event to fire if
    // they were left out... fun
    category: eventType,
    action: eventType
  }, AD_WORDS);
}

export function processHmdAnswers(uuid, reasonForVisitAnswer, bankingRelationshipAnswer, products) {
  // get answer for 'Are you a current customer of Regions?' (bankingRelationship)
  const bankingRelationshipEvent = {};

  let bankingAnswerArray = [];
  if (bankingRelationshipAnswer.length > 0 && bankingRelationshipAnswer[0] != undefined) {
    bankingRelationshipAnswer[0].forEach(v => {
      bankingAnswerArray.push(analyticsCustomerText[v]);
    });
  }
  const joinedBankingAnswers = bankingAnswerArray.join(',');
  bankingRelationshipEvent.hmdCustomer = joinedBankingAnswers;

  // get answer for 'Find the products that best fit your banking needs.' (reasonForVisit)
  const reasonForVisitEvent = {};

  let reasonForVisitEventAnswerArray = [];
  if (reasonForVisitAnswer.length > 0 && reasonForVisitAnswer[0] != undefined) {
    reasonForVisitAnswer[0].forEach(v => {
      reasonForVisitEventAnswerArray.push(analyticsHmdText[v]);
    });
  }

  const joinedReasonForVisitAnswers = reasonForVisitEventAnswerArray.join(',');
  reasonForVisitEvent.hmdFlow = joinedReasonForVisitAnswers;

  // get product recommendation IDs
  const recommendationsEvent = {};

  if (products.length > 0) {
    recommendationsEvent.hmdRecommend = products;
  }

  const events = {
    'events': 'combined',
    'uuid': uuid,
    ...bankingRelationshipEvent,
    ...reasonForVisitEvent,
    ...recommendationsEvent,
  };

  dispatchAnalyticsEvent(events);
}

export function installEnsighten(state) {
  const { guideConfigurations } = state;
  const runMode = guideConfigurations.runMode;
  const sysEnv = runMode === 'production' ? 'ignite-prod' : 'ignite-stage';

  const scriptElement = document.createElement('script');
  scriptElement.src = `//nexus.ensighten.com/regions/${sysEnv}/Bootstrap.js`;
  scriptElement.async = true;
  document.body.appendChild(scriptElement);
}

export function initGoogleAnalytics() {
  const isTest = false;
  ReactGA.initialize(
    [
      { trackingId: DC_FLOODLIGHT, gaOptions: { testMode: isTest }, },
      // todo: INIT OTHER TAGS HERE
      { trackingId: UNIVERSAL_ANALYTICS, gaOptions: { testMode: isTest }, },
      { trackingId: AD_WORDS, gaOptions: { testMode: isTest }, }
    ]
  );
  
  initMetaPixel();
}

export function initLinkedIn(){
  const channel = extractGuideChannel(window.location.host);
  if(channel === WEALTH){
    LinkedInTag.init(LINKEDIN_ID, 'px', false);
    LinkedInTag.init(LINKEDIN_REGIS_ID, 'px', false);
    LinkedInTag.init(LINKEDIN_WEALTH_ID, 'px', false);
  };
}


export const trackLinkedIn = () => {
  //conversionId not needed as client simply wants to track clicks
  LinkedInTag.track(null, LINKEDIN_ID, 'px');
}

export const trackJivoxPixel = (url = null) => {
  const builtUrl = `${url}&us_privacy=${getUSPrivacy()}`;
  if(url) {
    fetch(builtUrl)
      .catch(error => {
          console.error('There has been a problem with your fetch operation:', error);
      });
  }
}

export const processFloodLightDoubleClick = async (sendToInput) => {
  // Note: sendToInput obj is defined above as `sendTo`
  let isFinancialAdvisor;
  const channel = extractGuideChannel(window.location.host);

  let event = {
    'allow_custom_scripts': true,
    'send_to': sendToInput,
  }

  const assetsAmount = await ignite.answerService.getAnswer('assetsAmount');

  if (assetsAmount?.value) {
    isFinancialAdvisor = assetsAmount.value <= 500000 ? 'Financial Advisor' : 'Wealth Advisor';
  }

  if(sendTo.letsConnectSubmit === sendToInput) {
    const currentPageUrl = window.location.href;
    event.u14 = getUrl(currentPageUrl);
    event.u15 = isFinancialAdvisor;
    event.send_to = assetsAmount.value <= 500000 ? sendTo.financialAdvisor : sendTo.wealthAdvisor;
    
    if (assetsAmount?.value) {
      if (assetsAmount.value <= 500000) {
        trackMetaPixelEvent(META_PIXEL_EVENTS.regisLead);
      } else {
        trackMetaPixelEvent(META_PIXEL_EVENTS.wealthLead);
      }
    }
  }

  if (channel === WEALTH) {
    LinkedInTag.init(LINKEDIN_ID, 'px', false);

    if (assetsAmount.value <= 500000) {
      LinkedInTag.track(null, LINKEDIN_REGIS_ID, 'px');
    } else {
      LinkedInTag.track(null, LINKEDIN_WEALTH_ID, 'px');
    }

  };

  ReactGA.event('conversion', event)
}

export function initMetaPixel() {
  const options = {
    autoConfig: true,
    debug: true
  };
  ReactPixel.init(META_PIXEL_ID, undefined, options);
  
  /* 
   * Alternative implementations moved to meta_analytics.mjs:
   * - Direct script injection approach
   * - Noscript image fallback
   */
}

export function trackMetaPixelEvent(eventName) {
  console.log('trackMetaPixelEvent', eventName);
  
  ReactPixel.trackCustom(eventName);
  
  /* 
   * Alternative implementations moved to meta_analytics.mjs:
   * - Direct fbq tracking approach
   * - Image pixel fallback approach
   */
}